import { useEffect, useState } from 'react';
import services from '../services';
import {
  isTimeInBrowserSettings,
  type ServiceLocation,
} from '../helpers/appHelper';

const useIANATimeZone = (
  postalCode: string,
  serviceProductId: string,
  location?: ServiceLocation,
) => {
  const [IANATimeZone, setIANATimeZone] = useState<string>('');
  useEffect(() => {
    if (location && postalCode && serviceProductId) {
      const fetchTimeZone = async () => {
        let timeZone = '';
        if (isTimeInBrowserSettings(location, CSS_CONFIG)) {
          timeZone = Intl.DateTimeFormat().resolvedOptions().timeZone;
        } else {
          timeZone = await services.appointment.getIANATimeZone(
            postalCode,
            serviceProductId,
          );
        }

        if (timeZone) {
          setIANATimeZone(timeZone);
        }
      };

      fetchTimeZone();
    }
  }, [location, postalCode, serviceProductId]);

  return IANATimeZone;
};

export default useIANATimeZone;
